import * as React from 'react'
import classnames from 'classnames'
import { Props, State } from './types'
import './styles.scss';

export class Input extends React.Component<Props, State> {
  passwordEl: React.RefObject<any>

  constructor(props: Props) {
    super(props)

    this.state = {
      isActive: false,
      isVisible: true
    }

    this.passwordEl = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    // document.addEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(event: any) {
    if (this.passwordEl && this.passwordEl.current && !this.passwordEl.current.contains(event.target)) {
      this.setState({ isActive: false })
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { isActive } = this.state
    const { isActive: prevIsActive } = prevState

    if (this.passwordEl && this.passwordEl.current && this.passwordEl.current.value !== '') {
      if (isActive !== prevIsActive) {
        this.setState({ isActive: true });
      }
    }
  }

  render() {
    const {
      type,
      label,
      input,
      disabled,
      icon,
      withoutBorder,
      primary,
      secondary,
    } = this.props

    const { isActive } = this.state

    if (primary) {
      return (
        <div className={
          `input
            ${withoutBorder && `input--noBorder`}
            ${(isActive) ? 'isActive' : ''}
            ${disabled ? 'disabled' : ''}`
          }>
          { !withoutBorder && (
            <div
              className="input__label input__label__primary"
            >
              { label || '' }
            </div>
          )}
          <input
            name={input && input.name}
            className="input__field"
            type={type || 'text'}
            ref={this.passwordEl}
            disabled={disabled || false}
            placeholder={withoutBorder ? label : undefined}
            onFocus={() => this.setState({ isActive: true })}
            onBlur={() => this.setState({ isActive: false })}
            value={input && input.value}
            onChange={input && input.onChange}
          />
          { icon && (
            <div className="input__logo"> { icon } </div>
          )}
        </div>
      );
    }

    if (secondary) {
      return (
        <div className={
          `input
            ${withoutBorder && `input--noBorder`}
            ${disabled ? 'disabled' : ''}`
        }>
        <input
          className={classnames('input__field input__field__secondary', disabled ? 'input__field__secondary__disabled' : '')}
          name={input && input.name}
          type={type || 'text'}
          disabled={disabled || false}
          placeholder={label}
          value={input && input.value}
          onChange={input && input.onChange}
        />
          { icon && (
            <div className="input__logo"> { icon } </div>
          )}
      </div>
      )
    }

    return null
  }
}
